/*
  <viewers-counter>

  Renders the "N people are viewing this right now" figure in the Featured
  product section's Badges and tags block. The bounds come from the featured
  product's own metafields (custom.viewers_min / custom.viewers_max) and reach
  this element as data attributes — there is no live visitor feed behind it, so
  the component does no fetching and holds no shared state.

  Loaded only by sections/featured-product.liquid, and only when a
  badges_and_tags block has the setting on and the product carries both
  metafields (has_viewers_count_block), same conditional loading as coundown.js.
*/
if (!customElements.get('viewers-counter')) {
  /* Re-pick window. The delay is re-rolled on every tick so several counters on
     one page drift apart instead of updating in lockstep. */
  const VIEWERS_COUNTER_MIN_DELAY = 25000;
  const VIEWERS_COUNTER_MAX_DELAY = 40000;

  class ViewersCounter extends HTMLElement {
    constructor() {
      super();
      this._timer = null;
      this._output = null;
      this._min = 0;
      this._max = 0;
    }

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this._output = this.querySelector('[data-viewers-value]');
      this._min = parseInt(this.dataset.min, 10);
      this._max = parseInt(this.dataset.max, 10);

      if (!this._output || Number.isNaN(this._min) || Number.isNaN(this._max)) return;

      /* Tolerate a merchant entering the bounds the wrong way round. */
      if (this._max < this._min) {
        const swap = this._min;
        this._min = this._max;
        this._max = swap;
      }

      this._render();
      this._scheduleNext();
    }

    disconnectedCallback() {
      this.stop();
      this.dataset.initialized = 'false';
    }

    stop() {
      if (this._timer) clearTimeout(this._timer);
      this._timer = null;
    }

    _scheduleNext() {
      this.stop();

      const spread = VIEWERS_COUNTER_MAX_DELAY - VIEWERS_COUNTER_MIN_DELAY;
      const delay = VIEWERS_COUNTER_MIN_DELAY + Math.round(Math.random() * spread);

      this._timer = setTimeout(() => {
        this._render();
        this._scheduleNext();
      }, delay);
    }

    _render() {
      const value = this._min + Math.floor(Math.random() * (this._max - this._min + 1));
      this._output.textContent = String(value);
    }
  }

  customElements.define('viewers-counter', ViewersCounter);
}
